import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/components/HtmlLang.jsx");
